import {createSlice} from '@reduxjs/toolkit'

export const searchSlice = createSlice({
  name: 'search',
  initialState: {
    allProspectsSearch: {
      currentTerm: '',
      previousTerm: ''
    },
    savedProspectsSearch: {
      currentTerm: '',
      previousTerm: ''
    },
    prospectProfileSearch: '',
    resetSearchTerm: false
  },
  reducers: {
    updatedAllProspectsSearchTerm: (state, action) => {
      state.allProspectsSearch.currentTerm = action.payload.currentTerm
      state.allProspectsSearch.previousTerm = action.payload.previousTerm
    },
    updatedSavedProspectsSearchTerm: (state, action) => {
      state.savedProspectsSearch.currentTerm = action.payload.currentTerm
      state.savedProspectsSearch.previousTerm = action.payload.previousTerm
    },
    updateProspectProfileSearch: (state, action) => {
      state.prospectProfileSearch = action.payload
    },
    setResetSearchTerm: (state, action) => {
      state.resetSearchTerm = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const {
  updatedAllProspectsSearchTerm,
  updatedSavedProspectsSearchTerm,
  updateProspectProfileSearch,
  setResetSearchTerm
} = searchSlice.actions

export default searchSlice.reducer
